module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('LabelMenu', {
    staticStyle: {
      "color": "#888"
    },
    attrs: {
      "value": _vm.value[_vm.schema.name],
      "label": _vm.schema.label,
      "menus": _vm.schema.items,
      "underline": "black"
    },
    on: {
      "change": function($event) {
        return _vm.$emit('change', $event)
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1431b1f3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/forms/blocks/DropdownLabelControl.vue
// module id = 2458
// module chunks = 1